import UserSuggestionsComponent, { UserType } from './UserSuggestions.component';

export type UserSuggestionsProps = {
  reviewersSuggestions: UserType[];
  onAssign: (id: string) => void;
};

export default function UserSuggestions({
  reviewersSuggestions,
  onAssign,
  ...props
}: UserSuggestionsProps): JSX.Element {
  const onSelectItem = (id: string): void => {
    onAssign(id);
  };

  return (
    <UserSuggestionsComponent
      onSelectItem={onSelectItem}
      suggestions={reviewersSuggestions}
      {...props}
    />
  );
}
